<div *ngIf="!isLoading; else loading" class="dialog-container" [ngClass]="{ 'fixed-height': isModal, 'fixed-height-100': isSidePanelOnly }">
  <div *ngIf="isOverlaySidebarOpen || isSidePanelOnly" class="overlay-sidebar overlay-bg">
    <div *ngIf="!isSidePanelOnly" class="overlay-area" (click)="toggleInspection()"></div>
    <div class="panel" [ngClass]="{ 'panel-in-modal': isModal, 'w-100': isSidePanelOnly }">
      <div class="sidebar-header">
        <div class="back-btn" (click)="isSidePanelOnly ? handleClose() : toggleInspection()">
          <i class="fal fa-chevron-left font-blue pointer pr-1"></i>
          <span>{{ 'tech-app.back' | translate }}</span>
        </div>
      </div>
      <div class="container">
        <div class="subheader">
          <div class="inspection-subheader">{{ selectedCategory | titlecase }}</div>
          <div class="inspection-header">{{ helperService.getLocalizationValue(currentLang, selectedInspection, 'title') }}</div>
        </div>
        <div class="inspection-section">
          <div class="title">
            {{ 'tech-app.result' | translate }}
            <span *ngIf="isSelectedInspectionResultRequired()" class="required-mark">*</span>
          </div>
          <div class="result">
            <ng-container *ngTemplateOutlet="result; context: { id: selectedInspection._id, status: selectedInspection.status }"> </ng-container>
          </div>
          <div *ngIf="conditions?.length" class="title">{{ currentLang.toLowerCase() === 'fr' ? 'La Condition' : 'Conditions' }}</div>
          <!-- [ngStyle]="{'width': condition.width + '%'}" -->
          <div class="conditions">
            <ng-container *ngFor="let condition of conditions">
              <div class="parent-block">
                <div class="block" [ngClass]="{ 'selected-block': condition.isSelected, 'disable-inspection-modal': isReadOnly }" (click)="selectCondition(condition)">
                  {{ helperService.getLocalizationValue(currentLang, condition, 'name') }}
                </div>
              </div>
            </ng-container>
          </div>
          <div class="title" *ngIf="allMeasurements.length">Measurements</div>
          <ng-container *ngIf="allMeasurements.length">
          <div *ngFor="let item of allMeasurements" class="unit-wrapper">
            <p class="measurement-inspection-name">{{ item.name }}</p>
            <div class="inp-btn-wrapper">
              <input
                (input)="handleInputChange($event, item.name, item.units, item.id)"
                [value]="item.value > 0 ? item.value :  ''"
                maxlength="10"
                (keydown)="restrictInputLength($event)"
                (blur)="onInputBlur()"
                #inputElement
              />
              <div class="btn-wrapper">
                <ng-container>
                  <div
                    *ngFor="let unit of item.units"
                    class="unit-block"
                    [ngStyle]="getUnitStyles(unit._id, item.units)"
                    (click)="handleUnitClick(unit.text, item.name, unit._id, item.units, item.id,item.value)"
                  >
                    {{ unit.text }}
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
          </ng-container>
          <div class="title">
            {{ 'tech-app.attachments' | translate }}
            <span *ngIf="isSelectedInspectionRequired()" class="required-mark">*</span>
          </div>
          <div class="attachment">
            <div class="menuItem" *ngFor="let menuItem of menu" (click)="openRecorder(menuItem)">
              <input
                *ngIf="menuItem.type !== 'voice' && !imageUrl && !isIphone"
                [ngClass]="{ 'disable-inspection-modal': isReadOnly }"
                type="file"
                #fileInput
                [accept]="menuItem.type"
                class="attachment-input"
                [capture]="'environment'"
                (change)="onFileSelected(id, $event, menuItem.type ? menuItem.type : 'gallery')"
              />
              <input
                *ngIf="menuItem.type !== 'voice' && !imageUrl && isIphone && !isIpad"
                [ngClass]="{ 'disable-inspection-modal': isReadOnly }"
                type="file"
                #fileInput
                [accept]="menuItem.type"
                class="attachment-input"
                (change)="onFileSelected(id, $event, menuItem.type ? menuItem.type : 'gallery')"
              />
              <input
                *ngIf="menuItem.type !== 'voice' && !imageUrl && isIphone && isIpad"
                [ngClass]="{ 'disable-inspection-modal': isReadOnly }"
                type="file"
                #fileInput
                [accept]="menuItem.type"
                class="attachment-input"
                [ngClass]="{ 'disable-inspection-modal': isReadOnly }"
                (click)="fileInput.value = null; value = null"
                (change)="onFileSelected(id, $event, menuItem.type ? menuItem.type : 'gallery')"
              />
              <span *ngIf="!imageUrl" [ngClass]="{ 'attachment-item': menuItem.type !== 'voice' }"><img [src]="menuItem.icon" /></span>
              <span *ngIf="!imageUrl" [ngClass]="{ 'attachment-item': menuItem.type !== 'voice', 'disable-inspection-modal': isReadOnly }">{{
                currentLang === 'en' ? menuItem.name : menuItem.nameFR
              }}</span>
            </div>
            <!-- image editor -->
            <div *ngIf="imageUrl" class="editor" #imageEditor>
              <div *ngIf="editorEnabled" class="editor-toolbar">
                <div class="top-header">
                  <span (click)="hideEditor(true)">
                    <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M0.299683 9.99987C0.299683 9.64157 0.436499 9.28317 0.709512 9.00989L9.30928 0.410344C9.85633 -0.1367 10.7433 -0.1367 11.2901 0.410344C11.8369 0.957166 11.8369 1.84393 11.2901 2.39101L3.68065 9.99987L11.2896 17.609C11.8364 18.1559 11.8364 19.0428 11.2896 19.5895C10.7427 20.1368 9.85606 20.1368 9.30902 19.5895L0.709202 10.9901C0.436233 10.7167 0.299683 10.3583 0.299683 9.99987Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  <span (click)="toggleDrawableModal()">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M13.7678 8.59375C13.7678 8.16227 13.4181 7.8125 12.9866 7.8125H4.9397C4.50821 7.8125 4.15845 8.16227 4.15845 8.59375C4.15845 9.02523 4.50821 9.375 4.9397 9.375H12.9866C13.4181 9.375 13.7678 9.02523 13.7678 8.59375Z"
                        fill="white"
                      />
                      <path
                        d="M4.9397 10.9375C4.50821 10.9375 4.15845 11.2873 4.15845 11.7188C4.15845 12.1502 4.50821 12.5 4.9397 12.5H9.82685C10.2583 12.5 10.6081 12.1502 10.6081 11.7188C10.6081 11.2873 10.2583 10.9375 9.82685 10.9375H4.9397Z"
                        fill="white"
                      />
                      <path
                        d="M6.77569 18.4375H4.16284C3.30128 18.4375 2.60034 17.7366 2.60034 16.875V3.125C2.60034 2.26344 3.30128 1.5625 4.16284 1.5625H13.7679C14.6294 1.5625 15.3304 2.26344 15.3304 3.125V7.92969C15.3304 8.36117 15.6801 8.71094 16.1116 8.71094C16.5431 8.71094 16.8929 8.36117 16.8929 7.92969V3.125C16.8929 1.40188 15.491 0 13.7679 0H4.16284C2.43972 0 1.03784 1.40188 1.03784 3.125V16.875C1.03784 18.5981 2.43972 20 4.16284 20H6.77569C7.20718 20 7.55694 19.6502 7.55694 19.2188C7.55694 18.7873 7.20718 18.4375 6.77569 18.4375Z"
                        fill="white"
                      />
                      <path
                        d="M18.2767 11.3114C17.3629 10.3976 15.876 10.3975 14.9627 11.3108L10.6736 15.5904C10.5825 15.6813 10.5153 15.7933 10.4779 15.9164L9.54376 18.9916C9.46095 19.2643 9.53309 19.5603 9.73208 19.7643C9.88114 19.917 10.0836 20 10.2913 20C10.3608 20 10.431 19.9907 10.4999 19.9716L13.6532 19.0981C13.7829 19.0622 13.9012 18.9933 13.9965 18.8981L18.2767 14.626C19.1906 13.7122 19.1906 12.2253 18.2767 11.3114ZM13.0381 17.6472L11.4517 18.0866L11.9159 16.5581L14.81 13.6704L15.9151 14.7755L13.0381 17.6472ZM17.1724 13.5207L17.0211 13.6717L15.9162 12.5668L16.067 12.4163C16.3716 12.1117 16.8673 12.1117 17.1719 12.4163C17.4765 12.7209 17.4765 13.2165 17.1724 13.5207Z"
                        fill="white"
                      />
                      <path
                        d="M12.9866 4.6875H4.9397C4.50821 4.6875 4.15845 5.03727 4.15845 5.46875C4.15845 5.90023 4.50821 6.25 4.9397 6.25H12.9866C13.4181 6.25 13.7678 5.90023 13.7678 5.46875C13.7678 5.03727 13.4181 4.6875 12.9866 4.6875Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                </div>
              </div>
              <div class="edit-notes" *ngIf="isEditNotes">
                <div class="font-white font-700 font-14">Note</div>
                <div>
                  <app-textarea
                    theme="light"
                    styleClass="p-0"
                    styleClassInput="p-0 font-white"
                    [placeholder]="('tech-app.enter-notes-here' | translate) + ' ...'"
                    [autoGrow]="true"
                    [value]="imageNotes"
                    [hasBorderBottomOnActive]="false"
                    [maxAutoGrowHeight]="70"
                    [maxLength]="200"
                    (appChange)="handleImgNotesChange($event)"
                  ></app-textarea>
                </div>
              </div>

              <pintura-editor
                [class.translation-pintura-editor-fr]="currentLang === 'fr'"
                [options]="editorDefaults"
                (hide)="modalVisible = false"
                [imageCropAspectRatio]="0"
                [src]="imageUrl"
                [markupEditorToolStyles]="markupEditorToolStyles"
                [markupEditorToolbar]="markupEditorToolbar"
                util="annotate"
                [utils]="['annotate']"
                animations="true"
                [markupEditorShapeStyleControls]="markupEditorShapeStyleControls"
                [beforeSelectShape]="beforeSelectShape"
                (process)="handleEditorProcess($event)"
                [enableButtonRevert]="false"
                [enableButtonClose]="false"
                layoutVerticalToolbarPreference="bottom"
                (loadpreview)="handleLoadPreview($event)"
                (load)="handleOverlayLoad($event)"
                [willProcessImage]="willProcessImage"
                #pinturaEditor
              ></pintura-editor>
            </div>
          </div>
          <div *ngIf="selectedInspection?.attachments?.length || showRecorder" class="media-section">
            <div class="recordings" [ngClass]="{ 'voice-uploading': isVoiceUploading }" *ngIf="showRecorder">
              <div class="note-title">
                <span>{{'technical-notes' | translate}}</span>
              </div>
              <div class="recording-box">
                <div class="btn-menu">
                  <div class="media-btn" (click)="voiceRecord()">
                    <i *ngIf="!isRecording" class="fas fa-play text-black"></i>
                    <div *ngIf="isRecording" class="stop"></div>
                  </div>
                </div>
                <div class="time-display">
                  <span>{{ playingFormatedTime }}</span>
                </div>
              </div>
              <div *ngIf="isVoiceUploading" class="voice-loader">
                <i class="fal fa-spinner rotate"></i>
              </div>
            </div>
            <div class="recordings" *ngFor="let attachment of audioAttachments; let idx = index">
              <div class="note-title">
                <span>{{'technical-notes' | translate}}</span>
              </div>
              <div class="recording-box">
                <div class="btn-menu">
                  <div class="media-btn" (click)="playAudio(idx)">
                    <i *ngIf="!attachment.play" class="fas fa-play text-black"></i>
                    <img *ngIf="attachment.play" src="assets/img/pause.svg" />
                  </div>
                </div>
                <div class="time-display">
                  <span>{{ attachment.play ? formatTime(attachment.playingTime) : formatTime(attachment.recordingTime) }}</span>
                </div>
              </div>
            </div>
            <div *ngIf="attachmentCount" class="thumbnail" (click)="openGallery()">
              <ng-container *ngIf="thumbnail.type === 'image'; else video">
                <img class="thumbnail-imgs" [src]="thumbnail.url" />
              </ng-container>
              <ng-template #video>
                <video class="thumbnail-imgs">
                  <source [src]="thumbnail.url" type="video/mp4" />
                </video>
              </ng-template>
              <span *ngIf="!imageUrl" class="attachment-count">{{ attachmentCount > 5 ? '+5' : attachmentCount || 0 }}</span>
            </div>
          </div>
          <div class="title">{{ 'tech-app.notes' | translate }}</div>
          <div class="notes">
            <div class="editable-note-area orange-color">
              <textarea
                class="text-area"
                [ngClass]="{ 'disable-inspection-modal': isReadOnly }"
                [placeholder]="'tech-app.type-here' | translate"
                [(ngModel)]="selectedInspectionNote"
                maxlength="500"
                (keyup)="inspectionNoteChange($event)"
              ></textarea>
            </div>
            <div *ngIf="notes?.length" class="subtitle">
              <span *ngIf="!imageUrl" class="subtitle-icon"><img src="assets/img/icon/stars.svg" /></span>
              <div *ngIf="!imageUrl" class="title">{{ 'tech-app.canned-notes' | translate }}</div>
            </div>
            <div *ngIf="notes?.length" class="editable-note-area notes-suggestions">
              <div class="note-card" *ngFor="let note of notes" [ngClass]="{ 'disable-inspection-modal': isReadOnly }">
                <span class="canned-note">{{ note }}</span>
                <span *ngIf="!imageUrl" class="add-btn" (click)="addCannedNote(note)">+</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!isSidePanelOnly" class="sidebar-footer">
        <div class="nav-btn" [ngClass]="{ hide: isFirstInspection }" (click)="changeInspection(-1)">
          <i class="fal fa-chevron-left font-white pointer"></i>
          <span style="margin-left: 0.5vw">{{ 'tech-app.previous' | translate }}</span>
        </div>
        <div class="inspection-title">
          <span>{{ helperService.getLocalizationValue(currentLang, selectedInspection, 'title') }}</span>
        </div>
        <div class="nav-btn" (click)="changeInspection(1)">
          <span style="margin-right: 0.5vw">{{ isLastInspection ? ('tech-app.done' | translate) : ('tech-app.next' | translate) }} </span>
          <i class="fal fa-chevron-right font-white pointer"></i>
        </div>
      </div>
    </div>
  </div>
  <div class="header" *ngIf="!isSidePanelOnly">
    <div class="header-case">
      <div class="title">
        <span>{{ inspectionTitle }}</span>
      </div>
      <div *ngIf="windowWidth > mobileWindow" class="sub-title">
        <p>{{ inspectionPoints }} point inspection</p>
      </div>
    </div>
    <div class="header-actions">
      <div *ngIf="actualInspection.inspectionStatus !== 'completed'" class="close-btn" (click)="handleDone()">
        <span *ngIf="actualInspection.inspectionStatus !== 'completed' && windowWidth > mobileWindow">{{'tech-app.mark-as-complete' | translate}}</span>
        <span *ngIf="actualInspection.inspectionStatus !== 'completed' && windowWidth <= mobileWindow">{{'tech-app.done' | translate}}</span>
        <!-- <span *ngIf="actualInspection.inspectionStatus === 'completed'">{{ 'tech-app.close' | translate }}</span> -->
      </div>
      <!-- <div *ngIf="actualInspection.inspectionStatus !== 'completed'" class="cross-btn" (click)="handleCloseInspection()"> -->
      <div class="cross-btn" (click)="handleCloseInspection()">
        <img src="assets/img/icon/cross.svg" class="cross-icon" alt="Close" />
      </div>
    </div>
  </div>
  <div *ngIf="!isSidePanelOnly" class="body-containter" [ngClass]="{ 'bottom-padding': !isModal }" [ngStyle]="{ height: isOverlaySidebarOpen ? '94vh' : null }">
    <div class="status-bar" [ngClass]="{'filter-present': missingInspectionItems?.length}">
      <div class="left-section">
        <div class="data-block">
          <span class="label">{{ 'tech-app.customer' | translate }}:</span>
          <span class="value">{{ customerName | titlecase }}</span>
        </div>
        <div class="data-block">
          <span class="label">{{ 'tech-app.vehicle' | translate }}:</span>
          <span class="value">{{ vehicle?.name | titlecase }}</span>
        </div>
        <div class="spec-btn" (click)="openView()" tooltipPosition="top" [pTooltip]="!vehicle ? 'Select vehicle first' : ''">
          <span>{{ 'tech-app.view-specs' | translate }}</span>
        </div>
        <div *ngIf="windowWidth > mobileWindow" class="status-block data-block">
          <span class="value">{{ 'status' | translate }}:</span>
          <span [ngClass]="{
              'todo-tag': actualInspection.inspectionStatus === 'todo',
              'in-progress-tag': actualInspection.inspectionStatus === 'inProgress',
              'completed-tag': actualInspection.inspectionStatus === 'completed'
            }"
            class="value"
          >{{ actualInspection.inspectionStatus === inspectionStatuses.TODO ? ('tech-app.to-do' | translate) : actualInspection.inspectionStatus === inspectionStatuses.IN_PROGRESS ? ('tech-app.in-progress' | translate) :  ('tech-app.completed' | translate) }}</span>
        </div>
      </div>
    </div>

 <div class="filter-section" *ngIf="inspectionDifficulty === 'pro' && missingInspectionItems?.length && windowWidth > mobileWindow" (click)="toggleMissingFieldsView()">
    <img src="assets/img/icon/filter-bar-info-circle.svg" class="filter-info-icon" />
    <div class="filter-text-container">
    <span class="filter-count">{{ getTotalMissingItemsCount() }}</span>
    <span class="filter-text">{{'mandatory-items-remaining' | translate}}</span>
    </div>
      <img src="assets/img/icon/filter.svg" class="filter-icon" /> 
  </div>

  <div class="filter-section" *ngIf="inspectionDifficulty === 'pro' && missingInspectionItems?.length && windowWidth <= mobileWindow" (click)="toggleMissingFieldsView()">
    <img src="assets/img/icon/filter-bar-info-circle.svg" class="filter-info-icon" />
    <div class="filter-text-container">
    <span class="filter-count">{{ getTotalMissingItemsCount() }}</span>
    <span class="filter-text">{{'mandatory-items' | translate}}</span>
    </div>
      <img src="assets/img/icon/filter.svg" class="filter-icon" /> 
  </div>

    <div *ngIf="isFilterViewActive" class="missing-items-container" [ngStyle]="{ border: 'none' }">
      <div class="inspection-section" *ngFor="let missingCategory of missingInspectionItems">
        <div class="inspection-header flex-start-content">
          <span *ngIf="missingCategory.icon" class="icon">
            <img class="img" [src]="missingCategory.icon" />
          </span>
          <span class="title">
            {{ missingCategory.type }}
          </span>
        </div>
        
        <div class="" *ngIf="missingCategory.type === 'Overview' || missingCategory.type === 'Aperçu'">
          <div class="vehicle-overview vehicle-overview-in-modal">
            <div class="left-section missing-left-section-in-modal">
              <div class="img-block" [ngClass]="{ 'img-block-disable': stopImmediateUpload || isReadOnly }" *ngFor="let img of missingCategory.items[0].missingImages">
                <div class="label">
                  <span>{{img.label}}<span class="required-mark">*</span></span>
                </div>
                <div class="image">
                  <div *ngIf="!getOverviewImageSrc(img.id); else imgBox" class="no-img-container">
                    <input *ngIf="isIpad" type="file" #fileInput accept="/*" class="file-input" (click)="fileInput.value = null; value = null" (change)="onFileSelected(img.id, $event)" />
                    <input *ngIf="!isIpad" type="file" #fileInput accept="/*" class="file-input" (change)="onFileSelected(img.id, $event)" />
                    <span class="add-sign">+</span>
                    <span class="capture-label">{{ 'tech-app.capture' | translate }}</span>
                  </div>
                  <ng-template #imgBox>
                    <img class="img-container" [src]="getOverviewImageSrc(img.id)" />
                  </ng-template>
                </div>
                <div *ngIf="getOverviewImageSrc(img.id) && !isFinalized" class="remove-btn">
                  <div (click)="removeImg(img.id)" class="btn">{{ 'tech-app.remove' | translate }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="inspection" *ngIf="missingCategory.type !== 'Overview' && missingCategory.type !== 'Aperçu'">
          <ng-container *ngFor="let missingItem of missingCategory.items">
            <div class="inspection-item missing-inspection-item-required">
              <div class="btn-panel" [ngClass]="{ 'selected-cross': getItemStatus(missingItem.id) === 2, 'selected-view': getItemStatus(missingItem.id) === 1, 'selected-tick': getItemStatus(missingItem.id) === 0, 'disable-inspection-modal': isReadOnly }">
                <div class="tick pointer" (click)="handleStatus(missingItem.id, 0)">
                  <img class="icon-size" [src]="getItemStatus(missingItem.id) === 0 ? 'assets/img/icon/tick-white.svg' : 'assets/img/icon/tick.svg'" />
                </div>
                <div class="view pointer" (click)="handleStatus(missingItem.id, 1)">
                  <img class="icon-size" 
                       [src]="getItemStatus(missingItem.id) === 1 ? 'assets/img/icon/eye-white.svg' : 
                              (getItemStatus(missingItem.id) === -1 ? 'assets/img/icon/warning.svg' : 'assets/img/icon/eye.svg')" 
                  />
                </div>
                <div class="cross pointer" (click)="handleStatus(missingItem.id, 2)">
                  <img class="icon-size" [src]="getItemStatus(missingItem.id) === 2 ? 'assets/img/icon/cross-white.svg' : 'assets/img/icon/cross.svg'" />
                </div>
              </div>
              
              <div class="item" (click)="toggleInspection(missingItem.id)">
                <span class="name">
                  {{ missingItem.name }}
                  <span class="required-mark">*</span>
                </span>
              </div>
              
              <div *ngIf="missingItem.requirement !== 'Item Required'" class="photo-required-btn">
                <span class="btn">{{'tech-app.photo-required' | translate}}</span>
              </div>
              
              <div *ngIf="hasAttachments(missingItem.id)" class="action-item" (click)="toggleInspection(missingItem.id)">
                <div class="action">
                  <img src="assets/img/icon/gallery.svg" />
                  <div class="count-badge">{{ getAttachmentCount(missingItem.id) }}</div>
                </div>
                <div class="action">
                  <img src="assets/img/icon/writing.svg" />
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <ng-container *ngIf="!isFilterViewActive">
    <div class="inspection-section">
      <div class="inspection-header flex-start-content">
        <span class="icon">
          <img class="img" src="assets/img/icon/camera.svg" />
        </span>
        <span class="title">
          {{ 'tech-app.vehicle-overview' | translate }}
        </span>
      </div>
      <div class="vehicle-overview" [ngClass]="{ 'vehicle-overview-in-modal': isModal }">
        <div class="left-section" [ngClass]="{ 'left-section-in-modal': isModal }">
          <div class="img-block" [ngClass]="{ 'img-block-disable': stopImmediateUpload || isReadOnly }" *ngFor="let img of inspectionOverview">
            <ng-container *ngTemplateOutlet="imgBlock; context: { id: img.id, label: currentLang === 'en' ? img.label : img.labelFR, img: img.imgSrc }"></ng-container>
          </div>
        </div>
        <div class="right-section" [ngClass]="{ 'right-section-in-modal': isModal }">
          <div class="label">
            <span>{{ 'tech-app.technician-notes' | translate }}</span>
          </div>
          <div class="notes" [ngClass]="{ 'disable-inspection-modal': isReadOnly }">
            <app-textarea
              theme="border"
              [value]="technicalNotes"
              [placeholder]="'tech-app.type-here' | translate"
              [floatingLabel]="false"
              [autoGrow]="true"
              [maxAutoGrowHeight]="100"
              [fontSize]="14"
              [rows]="isModal ? 3 : windowWidth > tabWindow || windowWidth <= mobileWindow ? 5 : 3"
              (appChange)="handleChange($event)"
            >
            </app-textarea>
          </div>
        </div>
      </div>
    </div>
    </ng-container>
    <ng-container *ngIf="!isFilterViewActive">
    <div class="inspection-section" *ngFor="let inspection of inspections">
      <div class="inspection-header flex-start-content">
        <div *ngIf="!isMarkAllEnabledForDvi2" style="display: flex; justify-content: center; align-items: center; font-weight: 700; font-size: 20px">
          <span *ngIf="inspection.icon" class="icon">
            <img class="img" [src]="inspection.icon" />
          </span>
          <span class="title2">
            {{ inspection.type | uppercase }}
          </span>
        </div>
        <span *ngIf="inspection.icon && isMarkAllEnabledForDvi2" class="icon">
          <img class="img" [src]="inspection.icon" />
        </span>
        <span
          class="title"
          *ngIf="isMarkAllEnabledForDvi2"
          [ngClass]="{ 'title-in-modal': isModal }"
          [ngStyle]="{ 'padding-left': !inspection.icon ? '1vw' : '0', width: !inspection.icon ? '80%' : '65%' }"
        >
          {{ inspection.type }}
        </span>
        <div class="check-mark" *ngIf="isMarkAllEnabledForDvi2" [ngClass]="{ 'check-mark-in-modal': isModal, 'disable-inspection-modal': isReadOnly }">
          <input
            type="radio"
            id="mark-all-{{ inspection.type }}"
            name="{{ inspection.type }}"
            class="radio-btn"
            [checked]="inspectionMark[inspection.type]"
            (click)="handleMultiChange(inspection.type)"
          />
          <label class="mark-label">{{
            windowWidth > mobileWindow ? ('tech-app.mark-all-as' | translate) + ' ' + ('tech-app.check-and-ok' | translate) : ('tech-app.mark-all-as' | translate) + ' OK'
          }}</label>
        </div>
      </div>
      <div class="inspection">
        <ng-container *ngFor="let inspectionItem of inspection.items">
          <div
            class="inspection-item"
            [ngClass]="{
              'mb-0': !inspectionItem.selectedConditions?.length
            }"
          >
            <ng-container
              *ngTemplateOutlet="inspectionBlock; context: { id: inspectionItem.id, label: inspectionItem.label, status: inspectionItem.status, galleryCount: inspectionItem.galleryCount }"
            ></ng-container>

            <div *ngIf="(isItemRequired(inspectionItem.id) && isRequiredFieldEmpty(inspectionItem.id) && (inspectionItem.status === 0 || inspectionItem.status === 1 || inspectionItem.status === 2)) ||
              inspectionItem.showError && inspectionItem.errorMessage !== 'Item Required'"
              class="photo-required-btn">
              <span class="btn">Photo Required</span>
            </div>
        </div>
        <div class="inspection-conditions-wrapper" *ngIf="inspectionItem?.measurement?.length || inspectionItem?.selectedConditions?.length">
            <div class="concern-pills-wrapper" *ngIf="inspectionItem?.measurement?.length">
                <ng-container *ngFor="let item of inspectionItem.measurement">
                    <div class="concern-drag-pills black" *ngIf="item.value && item.unit">
                        {{item.value}} {{ item.unit}}
                    </div>
                </ng-container>
            </div>
            <div *ngIf="inspectionItem?.selectedConditions?.length" class="conditions-container">
                <ng-container
                    *ngTemplateOutlet="conditionBlock; context: {conditions: inspectionItem.selectedConditions}"></ng-container>
            </div>
        </div>
    </ng-container>
</div>
    </div>
    </ng-container>
    <div class="dummy-tech-iphone-height"></div>
  </div>
</div>

<ng-template #loading>
  <div class="loading">
    <i *ngIf="isLoading" class="fal fa-spinner rotate"></i>
  </div>
</ng-template>

<ng-template #imgBlock let-id="id" let-img="img" let-label="label">
  <div class="label">
    <span>{{label}}<span *ngIf="isOverviewImageRequired()" class="required-mark">*</span></span>
  </div>
  <div class="image">
    <div *ngIf="!img; else imgBox" class="no-img-container" [ngClass]="{ 'disable-inspection-modal': isReadOnly }">
      <input *ngIf="isIpad" type="file" #fileInput accept="/*" class="file-input" (click)="fileInput.value = null; value = null" (change)="onFileSelected(id, $event)" />
      <input *ngIf="!isIpad" type="file" #fileInput accept="/*" class="file-input" (change)="onFileSelected(id, $event)" />
      <span class="add-sign">+</span>
      <span class="capture-label">{{ 'tech-app.capture' | translate }}</span>
    </div>
    <ng-template #imgBox>
      <img class="img-container" src="{{ img }}" />
    </ng-template>
  </div>
  <div *ngIf="img && !isFinalized" class="remove-btn" [ngClass]="{ 'disable-inspection-modal': isReadOnly }">
    <div (click)="removeImg(id)" class="btn">{{ 'tech-app.remove' | translate }}</div>
  </div>
</ng-template>

<ng-template #inspectionBlock let-id="id" let-galleryCount="galleryCount" let-label="label" let-status="status">
  <ng-container *ngTemplateOutlet="result; context: { id: id, status: status }"></ng-container>
  <div class="item" (click)="toggleInspection(id, status)">
    <span class="name">
      {{ label }}
      <span *ngIf="isItemRequired(id)" class="required-mark">*</span>
    </span>
  </div>
  <div *ngIf="galleryCount" class="action-item" (click)="toggleInspection(id, status)">
    <div class="action">
      <img src="assets/img/icon/gallery.svg" />
      <div class="count-badge">{{ galleryCount }}</div>
    </div>
    <div class="action">
      <img src="assets/img/icon/writing.svg" />
    </div>
  </div>
</ng-template>

<ng-template #conditionBlock let-conditions="conditions">
  <div class="condition-tag" *ngFor="let condition of conditions">
    <span [innerHTML]="helperService.getLocalizationValue(currentLang, condition, 'name')"></span>
  </div>
</ng-template>

<ng-template #result let-id="id" let-status="status">
  <div class="btn-panel" [ngClass]="{ 'selected-cross': status === 2, 'selected-view': status === 1, 'selected-tick': status === 0, 'disable-inspection-modal': isReadOnly }">
    <div class="tick pointer" (click)="handleStatus(id, 0)">
      <img class="icon-size" [src]="status === 0 ? 'assets/img/icon/tick-white.svg' : 'assets/img/icon/tick.svg'" />
    </div>
    <div class="view pointer" (click)="handleStatus(id, 1)">
      <img class="icon-size" 
           [src]="status === 1 ? 'assets/img/icon/warning-white.svg' : 'assets/img/icon/warning.svg'" 
      />
    </div>
    <div class="cross pointer" (click)="handleStatus(id, 2)">
      <img class="icon-size" [src]="status === 2 ? 'assets/img/icon/cross-white.svg' : 'assets/img/icon/cross.svg'" />
    </div>
  </div>
</ng-template>
